/* ハンバーガーメニュー
========================================================*/
import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initFooterFunctions() {
    const mqPc = window.matchMedia(MEDIA_QUERIES.pc);
    

    (function(){
        
        let footerLinkToggle = $(".js-footerLinkToggle");
        
        footerLinkToggle.on("click", function(){
            if (mqPc.matches) return;
            let subMenu = $(this).next();

            $(this).toggleClass("is-active");  
            subMenu.slideToggle();
        })

        window.addEventListener("resize", function(){
            if(mqPc.matches) {
                footerLinkToggle.addClass("is-active");
                footerLinkToggle.next().slideDown();
            }
        })
    })();
}
